import React, { useEffect, useState } from 'react'
import {
  Card,
  Table,
  Button,
  Input,
  Divider,
  Row,
  Col,
  Modal,
  Form,
  Spin,
  Select,
  message,
  Tooltip,
  Tag,
  Checkbox
} from 'antd'
import IntlMessages from '../../../util/IntlMessages'
import { InputGroup } from 'reactstrap'
import { useHistory } from 'react-router-dom'
import ds from '../../../Services/DataServices'
import { rejects } from 'assert'
import {
  loadReceiptTemplates,
  loadReceiptTemplatesUpdated,
  loadReceiptTemplatesLoading
} from '../../../appRedux/actions/Setup'
import { setCommonConfigs } from '../../../appRedux/actions/CommonData'
import { useDispatch, useSelector } from 'react-redux'
import InfoToPrint from '../../../components/InfoToPrint'
import { OUTLETREGISTER_SCREEN } from '../../../constants/Pages'
import {
  READ,
  CREATE,
  UPDATE,
  DELETE
} from '../../../constants/RightsAndPermissions'
import { BEHAVIOUR_TYPE } from '../../../Services/DataServices'
import { getDecryptID, notAllowMsgCheck } from '../../../appRedux/actions'
import {
  ShowSaleDate,
  ShowSaleRefID,
  ShowSaleTax,
  ShowSaleTotalAmount,
  ShowSaleTotalTax,
  ZeeReportPayments
} from '../../../constants/GeneralSetting'
import { checkIsWeb, postDataToApp } from '../../../appRedux/actions/MobAppFn'
import { PostAppTypes } from '../../../constants/MobAppConstants'
import CustomScrollbars from '../../../util/CustomScrollbars'
import NotAllowedComponent from '../../../components/NotAllowedComponent'

const confirm = Modal.confirm
// function useForceUpdate() {
//   const [value, setValue] = React.useState(0); // integer state
//   return () => setValue((value) => value + 1); // update the state to force render
// }

const formItemLayoutReport = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
    md: { span: 24 }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
    md: { span: 24 }
  }
}

const initialValues = {
  SkuGeneration: '1',
  SellScreenBarcode: '1',
  PaymentTypes: '0'
}

const OutletsAndRegisters = () => {
  const history = useHistory()
  const [form] = Form.useForm()
  const dispatch = useDispatch()
  // const forceUpdate = useForceUpdate();

  const getReduxTemplatedData = useSelector(
    ({ Setup }) => Setup.receiptTemplatesData
  )
  const getReduxTemplatesLoading = useSelector(
    ({ Setup }) => Setup.isReceiptTemplateLoading
  )
  const getReduxTemplatesUpdated = useSelector(
    ({ Setup }) => Setup.isReceiptTemplateUpdated
  )
  const getReduxCommonSetting = useSelector(
    ({ commonConfigs }) => commonConfigs.pageCommonConfigs
  )
  const getIsTaxExclusive = useSelector(
    ({ MainSale }) => MainSale.getIsTaxExclusive
  )

  const [visible, setVisible] = useState(false)
  const [confirmLoading, setConfirmLoading] = useState(false) // change state
  const [confirmLoadingModal, setConfirmLoadingModal] = useState(false) // change state
  const [getCountryData, setgetCountryData] = useState([{ id: 0, label: '' }])
  const [outletData, setOutletData] = useState([])
  const [outletAllData, setOutletAllData] = useState([])
  const [outletActiveData, setOutletActiveData] = useState([])
  const [taxData, setTaxData] = useState([])
  const [getIsLoadTableData, setIsLoadTableData] = useState(false)
  const [getTemplatesLoading, setTemplatesLoading] = useState(true)
  const [getReceiptTemplates, setReceiptTemplates] = useState([])
  const [getAllowedConfig, setAllowedConfig] = useState({})
  const [getIsDisableCreate, setIsDisableCreate] = useState(true)
  const [getIsDisableUpdate, setIsDisableUpdate] = useState(true)
  const [getIsDisableDelete, setIsDisableDelete] = useState(true)
  const [getIsAllowRead, setIsAllowRead] = useState(false)
  const [getAccessLoading, setAccessLoading] = useState(true)
  const [getRights, setRights] = useState([])
  const [getPermissions, setPermissions] = useState([])
  const [getReportLoader, setReportLoader] = useState(false)
  const [getPayTypes, setPayTypes] = useState([])

  //rights & permissions
  React.useEffect(() => {
    if (!checkIsWeb().exist) {
      postDataToApp(PostAppTypes.PAGE_HEADER, 'setup.outletsandregistersTitle')
    }

    let commonData = getReduxCommonSetting
    let rites = []
    let permissions = []
    if (
      commonData &&
      commonData.storeCommonConfigs &&
      commonData.storeCommonConfigs.storeConfig &&
      commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission
    ) {
      if (
        commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission.rites &&
        commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission.rites
          .length > 0
      ) {
        rites =
          commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission.rites
        setRights(rites)
      }
      if (
        commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission
          .permission &&
        commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission
          .permission.length > 0
      ) {
        permissions =
          commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission.rites
        setPermissions(permissions)
      }
    }

    if (rites.length > 0) {
      if (rites.filter(a => a == READ).length > 0) {
        setIsAllowRead(true)
      }
      if (rites.filter(a => a == CREATE).length > 0) {
        setIsDisableCreate(false)
        //redirect from home
        // if (window.location.href.includes("/mainadd")) {
        //   setVisible(true);
        // }
      }
      // else {
      //   if (window.location.href.includes("/mainadd")) {
      //     message.info("User don't have the right to create.");
      //   }
      // }
      if (rites.filter(a => a == UPDATE).length > 0) {
        setIsDisableUpdate(false)
      }
      if (rites.filter(a => a == DELETE).length > 0) {
        setIsDisableDelete(false)
      }
    }

    let valPayDrop = []
    if (commonData && commonData.storeCommonConfigs) {
      setAccessLoading(false)

      if (
        commonData.storeCommonConfigs.storeConfig &&
        commonData.storeCommonConfigs.storeConfig.generalConfigs &&
        commonData.storeCommonConfigs.storeConfig.generalConfigs.length > 0
      ) {
        commonData.storeCommonConfigs.storeConfig.generalConfigs.map(dd => {
          // if (dd.key == ShowSaleRefID) {
          //   form.setFieldsValue({
          //     RefID: dd.value && dd.value == '1' ? true : false
          //   })
          // }
          // else if (dd.key == ShowSaleTax) {
          //   form.setFieldsValue({
          //     SaleTax: dd.value && dd.value == '1' ? true : false
          //   })
          // }
          if (dd.key == ShowSaleDate) {
            form.setFieldsValue({
              DateTime: dd.value && dd.value == '1' ? true : false
            })
          } else if (dd.key == ShowSaleTotalAmount) {
            form.setFieldsValue({
              TotalAmount: dd.value && dd.value == '1' ? true : false
            })
          }
          // else if (dd.key == ShowSaleTotalTax) {
          //   form.setFieldsValue({
          //     TotalTax: dd.value && dd.value == '1' ? true : false
          //   })
          // }
          else if (dd.key == ZeeReportPayments) {
            const val =
              dd.value && dd.value.includes(',')
                ? dd.value.split(',')
                : dd.value
                ? [dd.value]
                : ['0']
            // form.setFieldsValue({
            //   PaymentTypes: val
            // })
            valPayDrop = val
          }
        })
      }
    }

    if (valPayDrop && valPayDrop.length > 0) getPayListService(valPayDrop)
  }, [getReduxCommonSetting])

  useEffect(() => {
    dispatch(setCommonConfigs(OUTLETREGISTER_SCREEN))
    setConfirmLoading(true)
    // getTemplateService();
    ds.getCountries()
      .then(res => {
        setgetCountryData(res)
      })
      .then(() => {
        ds.getTaxList('', BEHAVIOUR_TYPE.GET)
          .then(res => {
            if (res && res.length > 0) {
              let array = res.map(e => {
                return {
                  id: parseInt(getDecryptID(e.salesTaxSId)),
                  salesTaxName: `${e.salesTaxName} (${e.salesTaxValue}%)`
                }
              })
              setTaxData(array)
            }
          })
          .catch(e => {
            notAllowMsgCheck(e)
            setConfirmLoading(false)
            // message.error("Something went wrong");
          })
      })
      .then(() => {
        getOutletListingData()
      })
      .catch(error => {
        setConfirmLoading(false)
      })
  }, [])

  function getOutletListingData () {
    ds.getOutletAndRegister({}, BEHAVIOUR_TYPE.GET)
      .then(res => {
        if (res && res.outletAndRegisterLists.length > 0) {
          let mappedAll = res.outletAndRegisterLists.map((e, key) => {
            return {
              key: e.outletSId,
              outletSId: e.outletSId,
              outletName: e.outletName,
              outletTax: e.outletTax,
              isOutletDeleted: e.isOutletDeleted,
              showDelete:
                res.outletAndRegisterLists.filter(
                  a => a.isOutletDeleted == false
                ).length == 1
                  ? '0'
                  : '1',
              registerInfo: e.registerInfo.length > 0 ? e.registerInfo : []
            }
          })
          let mappedActive = res.outletAndRegisterLists
            .filter(w => w.isOutletDeleted == false)
            .map((e, key) => {
              let activeReg =
                e.registerInfo.length > 0
                  ? e.registerInfo.filter(r => r.isRegDeleted == false)
                  : []
              return {
                key: e.outletSId,
                outletSId: e.outletSId,
                outletName: e.outletName,
                outletTax: e.outletTax,
                isOutletDeleted: e.isOutletDeleted,
                showDelete:
                  res.outletAndRegisterLists.filter(
                    a => a.isOutletDeleted == false
                  ).length == 1
                    ? '0'
                    : '1',
                registerInfo: activeReg
              }
            })
          setOutletData(mappedActive)
          setOutletActiveData(mappedActive)
          setOutletAllData(mappedAll)
          setIsLoadTableData(false)
          setConfirmLoading(false)
          if (res.allowedConfig) {
            setAllowedConfig(res.allowedConfig)
          }
        }
      })
      .catch(error => {
        notAllowMsgCheck(error)
        message.error('Something went wrong')
        setConfirmLoading(false)
        setIsLoadTableData(false)
      })
  }

  function getPayListService (dropVal) {
    ds.getPaymentTypeList('', BEHAVIOUR_TYPE.GET)
      .then(res => {
        if (res && res.length > 0) {
          const payTypesNames = []
          const payTypes = res.map(qq => {
            return {
              id: getDecryptID(qq.paymentTypeSId),
              name: qq.paymentTypeName
            }
          })
          payTypes.unshift({ id: '0', name: 'All Payment Types' })
          setPayTypes(payTypes)
          dropVal.map(aa => {
            if (payTypes.filter(qw => qw.id == aa).length > 0) {
              payTypesNames.push(payTypes.filter(qw => qw.id == aa)[0].name)
            }
          })

          form.setFieldsValue({
            PaymentTypes: payTypesNames
          })
        } else setPayTypes([])
      })
      .catch(error => {
        form.setFieldsValue({
          PaymentTypes: ['0']
        })
        // notAllowMsgCheck(error)
        // message.error('Something went wrong')
        // setConfirmLoading(false)
        // setIsLoadTableData(false)
      })
  }

  async function postReportSetting (body) {
    setReportLoader(true)
    await ds
      .postReportSettingService(body)
      .then(res => {
        message.success('Report Setting Updated Successfully')
        setReportLoader(false)
      })
      .catch(error => {
        message.error('Report Setting Update Failed')
        setReportLoader(false)
      })
  }

  async function delTempService (body, methodType) {
    // ;
    await ds
      .postReceiptTemplatesService(body, methodType)
      .then(res => {
        if (res == 'Deleted') {
          message.success('Template Deleted Successfully')
          dispatch(loadReceiptTemplatesUpdated(!getReduxTemplatesUpdated))
          // setTimeout(() => {
          //   // getTemplateService();
          // }, 2000);
        } else if (res.includes('default')) {
          setConfirmLoading(false)
          message.info(
            'Template is set to default, set another as default then delete',
            4000
          )
        } else {
          // setTemplatesLoading(false);
          dispatch(loadReceiptTemplatesLoading(false))
          message.warn('Server down, Try Again Later...')
        }
      })
      .catch(error => {
        notAllowMsgCheck(error)
        dispatch(loadReceiptTemplatesLoading(false))
        // setTemplatesLoading(false);

        message.error('Error Occured')
      })
  }

  const columns = [
    {
      title: <IntlMessages id='setup.outletsandregisters.col1' />,
      dataIndex: 'outletName',
      key: 'outletName',
      render: text => {
        return (
          <span style={{ fontWeight: '500', color: '#003366' }}>{text}</span>
        )
      }
    },
    {
      title: <IntlMessages id='setup.outletsandregisters.col2' />,
      dataIndex: 'outletTax',
      key: 'outletTax',
      render: text => {
        return <span style={{ fontWeight: '500' }}>{text}</span>
      }
    },
    {
      title: <IntlMessages id='products.promotionlisting.edit' />,
      dataIndex: 'edit',
      key: 'edit',
      render: (text, record) => {
        let isDeleted = record.isOutletDeleted
        let isShowDelete = record.showDelete
        if (isShowDelete == '1') {
          isShowDelete = getIsDisableDelete ? '0' : isShowDelete
        }
        return (
          <div>
            <span>
              {isDeleted ? (
                <Tag color='#f50'>
                  <strong>
                    <IntlMessages id='setup.outletlisting.mainOutlet.deleted' />
                  </strong>
                </Tag>
              ) : getIsDisableUpdate ? (
                <Tag color='#f50'>
                  <strong>
                    <IntlMessages id='dakarpos.allow.accessdenied' />
                  </strong>
                </Tag>
              ) : (
                <a
                  onClick={() =>
                    history.push(
                      `/Dashboard/setup/outletsandregisters/editoutlet/${record.outletSId}/${isShowDelete}`
                    )
                  }
                  className='pen-edit'
                >
                  <i className='icon icon-edit' />
                </a>
              )}
            </span>
          </div>
        )
      }
    }
  ]

  const ExpandedRowRenderView = props => {
    const record = props.data ? props.data : []
    const data =
      record.registerInfo && record.registerInfo.length > 0
        ? record.registerInfo
        : []
    const columnsReg = [
      {
        title: 'Register name',
        dataIndex: 'registerName',
        key: 'registerName',
        render: text => {
          return <span style={{ color: '#41af4b' }}>{text}</span>
        }
      },
      {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
        render: text => {
          return (
            <span
              style={{ color: text == 'Closed' ? 'red' : 'rgb(3, 143, 222)' }}
            >
              {text}
            </span>
          )
        }
      },
      {
        title: <IntlMessages id='products.promotionlisting.edit' />,
        dataIndex: 'edit',
        key: 'edit',
        render: (text, record) => {
          let isDeleted = record.isRegDeleted
          let isShowDelete =
            data.filter(q => q.isRegDeleted == false).length == 1 ? '1' : '0'
          if (getIsDisableDelete || outletData.length == 1) {
            isShowDelete = '2'
          }

          return (
            <div>
              <span>
                {isDeleted ? (
                  <Tag color='#f50'>
                    <strong>
                      <IntlMessages id='setup.outletlisting.mainOutlet.deleted' />
                    </strong>
                  </Tag>
                ) : getIsDisableUpdate ? (
                  <>
                    <Tag color='#f50'>
                      <strong>
                        <IntlMessages id='dakarpos.allow.accessdenied' />
                      </strong>
                    </Tag>
                  </>
                ) : (
                  <a
                    onClick={() =>
                      history.push(
                        `/Dashboard/setup/outletsandregisters/editregister/${record.registerSId}/${isShowDelete}`
                      )
                    }
                    className='pen-edit'
                  >
                    <i className='icon icon-edit' />
                  </a>
                )}
              </span>
            </div>
          )
        }
      }
    ]

    return (
      <>
        {record && record.outletSId && (
          <div className='div-flow mb-3'>
            {getAllowedConfig && getAllowedConfig.allowedRegisters > 0 ? (
              <>
                <Button
                  className='dk-btn-add float-right'
                  type='primary'
                  onClick={() =>
                    history.push(
                      `/Dashboard/Setup/outletsandregisters/addregister/${record.outletSId}`
                    )
                  }
                  disabled={getIsDisableCreate}
                >
                  <IntlMessages id='setup.outletlisting.mainOutlet.addreg' />
                </Button>
              </>
            ) : (
              <>
                <Tooltip
                  title={
                    <IntlMessages id='setup.outletlisting.mainOutlet.notallowreg' />
                  }
                  color={'red'}
                >
                  <Button className='custom-addreg-btn' type='primary' disabled>
                    <IntlMessages id='setup.outletlisting.mainOutlet.addreg' />
                  </Button>
                </Tooltip>
              </>
            )}
          </div>
        )}
        {data.length > 0 && (
          <Table
            className='gx-table-responsive'
            columns={columnsReg}
            dataSource={data}
            rowKey={record => (record.registerSId ? record.registerSId : [])}
          />
        )}
      </>
    ) //dataSource={data} pagination={false} />;
  }

  const handleCancel = () => {
    setVisible(false)
    setConfirmLoadingModal(false)
  }

  const redirectAddReceiptTemplate = () => {
    history.push('/Dashboard/Setup/OutletsAndRegisters/addtemplate')
  }

  const doSubmit = values => {
    setConfirmLoadingModal(true)
    ds.postOutletAndRegister(
      {
        RegName: values.registerName,
        OutletName: values.outletName,
        OutletAddress: values.streetAddress,
        OutletCity: values.city,
        CountryId: values.country,
        StoreOutletTaxID: values.tax, // getIsTaxExclusive ? values.tax : 0,
        Behavior: 1,
        IsForOutlet: true
      },
      BEHAVIOUR_TYPE.POST
    )
      .then(res => {
        message.success('Data saved successfully')
        setConfirmLoadingModal(false)
        form.resetFields()
        setVisible(false)
        setIsLoadTableData(true)
        getOutletListingData()
      })
      .catch(error => {
        notAllowMsgCheck(error)
        setConfirmLoadingModal(false)
        message.error('Something went wrong')
      })
  }

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 8 },
      md: { span: 24 }
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 16 },
      md: { span: 24 }
    }
  }

  function deleteTemplate (id) {
    let body = new FormData()
    body.append('TemplateID', id)
    body.append('Behavior', 2)
    // setTemplatesLoading(true);
    dispatch(loadReceiptTemplatesLoading(true))
    delTempService(body, BEHAVIOUR_TYPE.DELETE)
  }

  const TemplateColumns = [
    {
      title: <IntlMessages id='setup.outletsandregisters.tempcol1' />,
      dataIndex: 'templateName',
      key: 'templateName',
      render: text => {
        return (
          <span style={{ fontWeight: '500', color: '#003366' }}>{text}</span>
        )
      }
    },
    {
      title: <IntlMessages id='setup.outletsandregisters.tempcol2' />,
      dataIndex: 'edit',
      key: 'edit',
      render: (text, record) => {
        return getIsDisableUpdate ? (
          <Tag color='#f50'>
            <strong>
              <IntlMessages id='dakarpos.allow.accessdenied' />
            </strong>
          </Tag>
        ) : (
          <div>
            <span>
              <a
                onClick={() =>
                  history.push(
                    `/Dashboard/setup/outletsandregisters/edittemplate/${record.templateID}`
                  )
                }
                className='pen-edit'
              >
                <i className='icon icon-edit' />
              </a>
            </span>
          </div>
        )
      }
    },
    {
      title: <IntlMessages id='products.brands.delete' />,
      key: 'delete',
      render: (text, record) => {
        function showDeleteConfirmPro () {
          // ;
          confirm({
            title: 'Are you sure remove this Template?',
            content: `"${record.templateName}"`,
            okText: 'Yes',
            cancelText: 'No',
            okButtonProps: { className: 'dk-btn-add close-reg-btn' },
            cancelButtonProps: { className: 'dk-btn-cancel close-reg-btn' },
            onOk () {
              deleteTemplate(record.templateID)
            },
            onCancel () {
              //console.log('Cancel');
            }
          })
        }

        return getIsDisableDelete ? (
          <Tag color='#f50'>
            <strong>
              <IntlMessages id='dakarpos.allow.accessdenied' />
            </strong>
          </Tag>
        ) : (
          <span>
            <a
              onClick={() => showDeleteConfirmPro()}
              style={{ color: 'red' }}
              className='gx-link'
            >
              <i className='icon icon-trash' />
            </a>
          </span>
        )
      }
    }
  ]

  const onFinish = values => {
    if (values) {
      const payVal = []
      values.PaymentTypes &&
        values.PaymentTypes.length > 0 &&
        values.PaymentTypes.map(qq => {
          payVal.push(getPayTypes.filter(as => as.name == qq)[0].id)
        })
      const body = {
        // ShowRefID: values.RefID ? values.RefID : false,
        // ShowSaleTax: values.SaleTax ? values.SaleTax : false,
        ShowSaleDate: values.DateTime ? values.DateTime : false,
        ShowTotalAmount: values.TotalAmount ? values.TotalAmount : false,
        // ShowTotalTax: values.TotalTax ? values.TotalTax : false,
        PaymentTypes: payVal && payVal.length > 0 ? payVal.toString() : '0'
      }
      postReportSetting(body)
    }
  }

  const onFinishFailed = errorInfo => {
    message.warn('Kindly Attend to Missing Fields')
  }

  const ReportSetting = () => {
    return (
      <Spin
        tip={<IntlMessages id='sell.cashlisting.cashloading' />}
        spinning={getReportLoader}
        size='large'
      >
        <div className='ReportSetting-div'>
          <h2 class='custom-font-weight-500 custom-font-color-black rs-size mt-2 mb-4'>
            <IntlMessages id='setup.xz.report.setting' />
          </h2>

          <div className='div-flow'>
            <h5 className='mb-0'> <IntlMessages id='setup.xz.report' />: </h5>

            <Form
              {...formItemLayoutReport}
              form={form}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              className='custom-mg-top-26'
              scrollToFirstError
              id='ReportSetting'
              name='ReportSetting'
              initialValues={initialValues}
            >
              <Row className='mt-3'>
                <Col md={8} xs={24} className='form-inner-pad-0 pl-0-device'>
                  <Form.Item
                    className='ant-form-item-label-custom ant-form-margin-right ant-form-custom-alignment'
                    name={'DateTime'}
                    label={<span>Sale Date & Time</span>}
                    valuePropName='checked'
                  >
                    <Checkbox size='large'>
                      Allow Sale Date & Time to show on X & Z report receipt
                    </Checkbox>
                  </Form.Item>
                </Col>
                <Col md={8} xs={24} className='form-inner-pad-0 md-pad-0'>
                  <Form.Item
                    className='ant-form-item-label-custom ant-form-margin-right ant-form-custom-alignment'
                    name={'TotalAmount'}
                    label={<span>Total Sales Amount</span>}
                    valuePropName='checked'
                  >
                    <Checkbox size='large'>
                      Allow Total Sales Amount to show on X & Z report receipt
                    </Checkbox>
                  </Form.Item>
                </Col>
                <Col md={8} xs={24} className='form-inner-pad-0 pr-0-device'>
                  <Form.Item
                    className='ant-form-item-label-custom ant-form-margin-right ant-form-custom-alignment'
                    name={'PaymentTypes'}
                    label={<span>Payment Types</span>}
                  >
                    <Select
                      placeholder='Select Payment Types'
                      mode='multiple'
                      size='middle'
                      showSearch={checkIsWeb().exist}
                      optionFilterProp='children'
                    >
                      {getPayTypes &&
                        getPayTypes.map(e => {
                          return (
                            <Select.Option value={e.name} key={e.id}>
                              {e.name}
                            </Select.Option>
                          )
                        })}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
            </Form>

            <div className='div-flow text-right'>
              <Button
                className='dk-btn-add'
                type='primary'
                form={'ReportSetting'}
                htmlType='submit'
                size='large'
              >
                <IntlMessages id='setup.general.saveBtn' />
              </Button>
            </div>
          </div>
        </div>
      </Spin>
    )
  }

  return getIsAllowRead ? (
    <Spin
      tip={<IntlMessages id='sell.cashlisting.cashloading' />}
      spinning={confirmLoading}
      size='large'
    >
      <>
        <div className='Content-wrapper Outlets&Registers-pg'>
          <Row className='align-items-center justify-content-between mb-3 RegisterClosureSummary-header'>
            {checkIsWeb().exist && (
              <Col lg={12} md={12} sm={24} xs={24}>
                <h1 className='mb-0'>
                  <IntlMessages id='setup.outletsandregistersTitle' />
                </h1>
              </Col>
            )}
            <Col
              lg={checkIsWeb().exist ? 12 : 24}
              md={checkIsWeb().exist ? 12 : 24}
              sm={24}
              xs={24}
              className='text-right'
            >
              <div className='pg-header-btn mt-10-md'>
                <Button
                  className='dk-btn-add'
                  type='primary'
                  onClick={redirectAddReceiptTemplate}
                  disabled={getIsDisableCreate}
                  size='large'
                >
                  <IntlMessages id='setup.outletsandregistersAddReceipt' />
                </Button>

                {getAllowedConfig && getAllowedConfig.allowedOutlets > 0 ? (
                  <>
                    <Button
                      className='dk-btn-add'
                      type='primary'
                      onClick={() => setVisible(true)}
                      disabled={getIsDisableCreate}
                      size='large'
                    >
                      <IntlMessages id='setup.outletsandregistersAddBut' />
                    </Button>
                  </>
                ) : (
                  <>
                    <Tooltip
                      title={
                        <IntlMessages id='setup.outletlisting.mainOutlet.notallowout' />
                      }
                      color={'red'}
                    >
                      <Button
                        style={{
                          fontWeight: 'bold'
                        }}
                        disabled
                        size='large'
                      >
                        <IntlMessages id='setup.outletsandregistersAddBut' />
                      </Button>
                    </Tooltip>
                  </>
                )}
              </div>
            </Col>
          </Row>

          <div className='mb-3'>
            <Row>
              <Col span={24}>
                <Select
                  defaultValue='0'
                  // onChange={handleChange}
                  size='large'
                  onChange={e => {
                    if (e == '0') {
                      setOutletData(outletActiveData)
                    } else if (e == '1') {
                      setOutletData(outletAllData)
                    }
                  }}
                >
                  <Select.Option value='0'>
                    <IntlMessages id='outletreg.dropdown.active' />
                  </Select.Option>
                  <Select.Option value='1'>
                    <IntlMessages id='outletreg.dropdown.all' />
                  </Select.Option>
                </Select>
              </Col>
            </Row>
          </div>

          <Table
            className='gx-table-responsive MinWidth-auto'
            columns={columns}
            expandedRowRender={record => {
              return <ExpandedRowRenderView data={record} />
            }}
            dataSource={outletData}
            rowKey={record => (record.outletSId ? record.outletSId : [])}
            loading={getIsLoadTableData}
          />

          <ReportSetting />

          <div className='mt-3'>
            <h2 class='custom-font-weight-500 custom-font-color-black heading-fonts-adjust'>
              <IntlMessages id='setup.outletsandregistersReceiptTitle' />
            </h2>

            <Table
              className='gx-table-responsive'
              columns={TemplateColumns}
              dataSource={getReduxTemplatedData}
              loading={getReduxTemplatesLoading}
            />
          </div>
        </div>

        <Modal
        className='AddNewOutlet-Modal'
          title={<IntlMessages id='setup.outletsandregistersPopUpTitle' />}
          visible={visible}
          okText={<IntlMessages id='setup.outletsandregisters.nextBtn' />}
          confirmLoading={confirmLoadingModal}
          centered={true}
          okButtonProps={{
            className: 'dk-btn-add'
          }}
          cancelButtonProps={{
            className: 'dk-btn-cancel'
          }}
          onOk={() => {
            form
              .validateFields()
              .then(values => {
                if (getIsDisableCreate)
                  message.warn('You do not have right to perform this', 5)
                else doSubmit(values)
              })
              .catch(info => {
                // console.log("Validate info",info)
              })
          }}
          onCancel={handleCancel}
          width={700}
        >
            <CustomScrollbars className='gx-layout-sider-scrollbar msHeight'>
          <Form
            {...formItemLayout}
            form={form}
            // onFinish={onFinish}
            // onFinishFailed={onFinishFailed}
            initialValues={{
              prefix: '86',
              tax: 1
            }}
            className='custom-mg-top-26'
            scrollToFirstError
            id='AddOutletForm'
            name='AddOutletForm'
          >
            <Col lg={24} md={24} sm={24} xs={24}>
              <div>
                <h3 className='mb-0'>
                  <IntlMessages id='setup.outletsandregisters.whereTitle' />
                </h3>
                <p className='custom-outlet-heading'>
                  <IntlMessages id='setup.outletsandregisters.whereDescription' />
                </p>
              </div>
              <Form.Item
                className='ant-form-item-label-custom ant-form-margin-right ant-form-custom-alignment'
                name='streetAddress'
                label={
                  <span>
                    <IntlMessages id='setup.outletsandregisters.streetLabel' />
                  </span>
                }
              >
                <Input size='large' placeholder='Enter Street Address' maxLength={200}/>
              </Form.Item>
              <InputGroup size='small' className='gx-mb-3'>
                <Form.Item
                  className='ant-form-item-label-custom ant-form-margin-right ant-form-custom-alignment'
                  name='city'
                  label={
                    <span>
                      <IntlMessages id='setup.outletsandregisters.city' />
                    </span>
                  }
                >
                  <Input size='large' placeholder='Enter City ' maxLength={20} />
                </Form.Item>
                <Form.Item
                  className='ant-form-item-label-custom ant-form-margin-right ant-form-custom-alignment'
                  name='country'
                  label={
                    <span>
                      <IntlMessages id='setup.outletsandregisters.country' />
                    </span>
                  }
                >
                  <Select
                    showSearch={checkIsWeb().exist}
                    optionFilterProp='children'
                    size='large'
                  >
                    {getCountryData &&
                      getCountryData.map(e => {
                        return (
                          <Select.Option value={e.id} key={e.id}>
                            {e.label}
                          </Select.Option>
                        )
                      })}
                  </Select>
                </Form.Item>
              </InputGroup>

              <Divider className='mt-3 mb-4' />

              <div>
                <h3 className='mb-0'>
                  <IntlMessages id='setup.outletsandregisters.nameTitle' />
                </h3>
                <p className='custom-outlet-heading'>
                  <IntlMessages id='setup.outletsandregisters.nameDescription' />
                </p>
              </div>
              <Form.Item
                className='ant-form-item-label-custom ant-form-margin-right ant-form-custom-alignment'
                name='outletName'
                label={
                  <span>
                    <IntlMessages id='setup.outletsandregisters.outletNameLabel' />
                  </span>
                }
                rules={[
                  {
                    required: true,
                    message: (
                      <IntlMessages id='setup.outletsandregisters.required' />
                    )
                  }
                ]}
              >
                <Input size='large' placeholder='Enter outlet name'  maxLength={50} />
              </Form.Item>

              <Divider className='mt-4 mb-4' />

              <div>
                <h3 className='mb-0'>
                  <IntlMessages id='setup.outletsandregisters.taxTitle' />
                </h3>
                <p className='custom-outlet-heading'>
                  <IntlMessages id='setup.outletsandregisters.taxDescription' />
                </p>
              </div>
              <InputGroup size='large' className='gx-mb-3'>
                <Form.Item
                  className='ant-form-item-label-custom ant-form-margin-right ant-form-custom-alignment'
                  name='tax'
                  label={
                    <span>
                      <IntlMessages id='setup.outletsandregisters.taxLabel' />
                    </span>
                  }
                  rules={[
                    {
                      required: true,
                      message: (
                        <IntlMessages id='setup.outletsandregisters.required' />
                      )
                    }
                  ]}
                >
                  <Select
                    size='large'
                    placeholder={
                      <IntlMessages id='setup.outletsandregisters.taxLabel' />
                    }
                    showSearch={checkIsWeb().exist}
                    optionFilterProp='children'
                  >
                    {taxData &&
                      taxData.map((e, key) => {
                        return (
                          <Select.Option value={e.id} key={key}>
                            {e.salesTaxName}
                          </Select.Option>
                        )
                      })}
                  </Select>
                </Form.Item>
              </InputGroup>

              <Divider className='mt-3 mb-4' />

              <div>
                <h3 className='mb-0'>
                  <IntlMessages id='setup.outletsandregisters.registeritle' />
                </h3>
                <p className='custom-outlet-heading'>
                  <IntlMessages id='setup.outletsandregisters.registerDescription' />
                </p>
              </div>
              <Form.Item
                className='ant-form-item-label-custom ant-form-margin-right ant-form-custom-alignment'
                name='registerName'
                label={
                  <span>
                    <IntlMessages id='setup.outletsandregisters.registerLabel' />
                  </span>
                }
                rules={[
                  {
                    required: true,
                    message: (
                      <IntlMessages id='setup.outletsandregisters.required' />
                    )
                  }
                ]}
              >
                <Input
                  size='large'
                  placeholder='Enter register name (eg Front counter)'  maxLength={80} 
                />
              </Form.Item>
            </Col>
          </Form>
          </CustomScrollbars>
        </Modal>
      </>
    </Spin>
  ) : (
    <NotAllowedComponent getAccessLoading={getAccessLoading} textType={1} />
  )
}

export default OutletsAndRegisters
